import {
  DONUT_CENTER,
  DONUT_CIRCUMFERENCE,
  DONUT_RADIUS,
  DONUT_SIZE,
  DONUT_STROKE_WIDTH,
  getFontSize,
} from "./constants";
import { RingSvg } from "./styles";
import { DonutRingProps } from "./types";

export const DonutRing: React.FC<DonutRingProps> = ({
  progress,
  color,
  secondaryProgress,
  secondaryColor,
  displayValue,
  size = DONUT_SIZE,
}) => {
  const p = Math.min(Math.max(progress, 0), 1);
  const primaryOffset = DONUT_CIRCUMFERENCE * (1 - p);
  const primaryRotation = -90;

  const sp =
    secondaryProgress === undefined
      ? 0
      : Math.min(Math.max(secondaryProgress, 0), 1);
  const secondaryOffset = DONUT_CIRCUMFERENCE * (1 - sp);
  const secondaryRotation = -90 + p * 360;

  const hasDualRing =
    secondaryProgress !== undefined && secondaryColor !== undefined;

  const fontSize = getFontSize(displayValue.length);

  return (
    <RingSvg
      width={size}
      height={size}
      viewBox={`0 0 ${DONUT_SIZE} ${DONUT_SIZE}`}
    >
      <circle
        cx={DONUT_CENTER}
        cy={DONUT_CENTER}
        r={DONUT_RADIUS}
        fill="none"
        stroke="var(--color-border-donut)"
        strokeWidth={DONUT_STROKE_WIDTH}
        opacity={0.25}
      />
      {hasDualRing ? (
        <>
          <circle
            cx={DONUT_CENTER}
            cy={DONUT_CENTER}
            r={DONUT_RADIUS}
            fill="none"
            stroke={color}
            strokeWidth={DONUT_STROKE_WIDTH}
            strokeDasharray={DONUT_CIRCUMFERENCE}
            strokeDashoffset={primaryOffset}
            strokeLinecap="round"
            transform={`rotate(${primaryRotation} ${DONUT_CENTER} ${DONUT_CENTER})`}
          />
          <circle
            cx={DONUT_CENTER}
            cy={DONUT_CENTER}
            r={DONUT_RADIUS}
            fill="none"
            stroke={secondaryColor}
            strokeWidth={DONUT_STROKE_WIDTH}
            strokeDasharray={DONUT_CIRCUMFERENCE}
            strokeDashoffset={secondaryOffset}
            strokeLinecap="round"
            transform={`rotate(${secondaryRotation} ${DONUT_CENTER} ${DONUT_CENTER})`}
          />
        </>
      ) : (
        <circle
          cx={DONUT_CENTER}
          cy={DONUT_CENTER}
          r={DONUT_RADIUS}
          fill="none"
          stroke={color}
          strokeWidth={DONUT_STROKE_WIDTH}
          strokeDasharray={DONUT_CIRCUMFERENCE}
          strokeDashoffset={primaryOffset}
          strokeLinecap="round"
          transform={`rotate(${primaryRotation} ${DONUT_CENTER} ${DONUT_CENTER})`}
        />
      )}
      <text
        x={DONUT_CENTER}
        y={DONUT_CENTER}
        textAnchor="middle"
        dominantBaseline="central"
        fill="var(--color-text-default)"
        fontSize={fontSize}
        fontWeight={700}
        fontFamily="'Crimson Pro', sans-serif"
        letterSpacing="-0.3"
      >
        {displayValue}
      </text>
    </RingSvg>
  );
};
